interface IFullWidthBG {
    className: string
}

const FullWidthBG = ({ className }: IFullWidthBG) => {
    return <div className={`${className} s1-full-width-bg`} />
}

export default FullWidthBG
